export type EnvTypes = 'dev' | 'feature' | 'pre' | 'uat' | 'prod' | 'daily' | 'beta';

export const ENV = process.env.REACT_APP_ENV || '';

export const envs = ['feature', 'pre', 'uat', 'prod', 'daily', 'beta'];
export const isDev = ['dev'].includes(ENV);
export const isFeature = ['feature'].includes(ENV);

export const isDaily = ['daily'].includes(ENV);
export const isBeta = ['beta'].includes(ENV);
export const isUat = ['uat'].includes(ENV);
export const isProd = envs.includes(ENV);
export const isRealProd = ['prod'].includes(ENV);
export const MARKETING = (process.env.REACT_APP_MARKETING || '') as 'HK' | 'MY' | 'SG' | '';
export const isHK = MARKETING === 'HK';
export const isMY = MARKETING === 'MY';
